import { Button } from "antd"
import { useCallback } from "react"

import Flex from "#blocks/Flex"
import { ATTENDANCE_STATUSES } from "#constants/globalConstants"
import { ClassSessionConstructor } from "#customTypes/composedTypes/classSessionTypes"
import { AttendanceClassSessions, AttendanceStatus } from "#customTypes/types"
import { getNow } from "#utils/dateHelpers"

// Find all sessions that have no attendance yet
const findValidSessionsToAdd = (classAttendance: AttendanceClassSessions) => {
  return classAttendance.map(({ status }) => {
    return status !== ATTENDANCE_STATUSES.INVALID
  })
}

const VALID_REMOVE_STATUSES: AttendanceStatus[] = [
  ATTENDANCE_STATUSES.ENROLLED,
  ATTENDANCE_STATUSES.NOT_ENROLLED,
  ATTENDANCE_STATUSES.INVALID,
] as const

const findValidSessionsToRemove = (
  classAttendance: AttendanceClassSessions
) => {
  return classAttendance.map(({ status }) => {
    return VALID_REMOVE_STATUSES.includes(status)
  })
}

const AddRemoveButtonRow = ({
  attendanceForClass,
  sortedClassSessions,
  selectedSessions,
  setSelectedSessions,
}: {
  attendanceForClass: AttendanceClassSessions
  sortedClassSessions: ClassSessionConstructor[]
  selectedSessions: boolean[]
  setSelectedSessions: (sessions: boolean[]) => void
}) => {
  // Pass in desired sessions and we adjust any valid ones
  // Use sortedClassSessions for eventStart so we can find future sessions
  const handleSelectSessions = useCallback(
    (addFuture: boolean) => {
      const validSessions = findValidSessionsToAdd(attendanceForClass)

      if (!addFuture) {
        setSelectedSessions(validSessions)
        return
      }

      const now = getNow().startOf("day").toISOString()
      const newSelectedSessions = sortedClassSessions.map((session, i) => {
        const isValid = validSessions[i]

        if (session.eventStart >= now && isValid) {
          return true
        }

        return selectedSessions[i]
      })
      setSelectedSessions(newSelectedSessions)
    },
    [
      attendanceForClass,
      sortedClassSessions,
      selectedSessions,
      setSelectedSessions,
    ]
  )

  const handleRemoveSessions = useCallback(
    (removeFuture?: boolean) => {
      const validSessions = findValidSessionsToRemove(attendanceForClass)

      if (!removeFuture) {
        setSelectedSessions(validSessions.map((v) => !v))
        return
      }
      const now = getNow().startOf("day").toISOString()
      const newSelectedSessions = sortedClassSessions.map((session, i) => {
        const isValid = validSessions[i]

        if (removeFuture && session.eventStart >= now) {
          return !isValid
        }

        return selectedSessions[i]
      })
      setSelectedSessions(newSelectedSessions)
    },
    [
      attendanceForClass,
      sortedClassSessions,
      selectedSessions,
      setSelectedSessions,
    ]
  )

  return (
    <Flex
      style={{
        justifyContent: "space-between",
        margin: "10px 20px 20px 0",
      }}
    >
      <Button
        variant="outlined"
        // size="small"
        onClick={() => handleSelectSessions(false)}
      >
        Select all
      </Button>
      <Button
        variant="outlined"
        // size="small"
        onClick={() => handleSelectSessions(true)}
      >
        Select all future
      </Button>
      <Button
        // size="small"
        danger
        onClick={() => handleRemoveSessions(false)}
      >
        Remove all
      </Button>
      <Button
        // size="small"
        danger
        onClick={() => handleRemoveSessions(true)}
      >
        Remove all future
      </Button>
    </Flex>
  )
}

export default AddRemoveButtonRow
